export const itemsBaseApiPath = '/api/common/orders';

import {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen,
  addItemGen,
  editItemGen
} from '../../../utils/apiHelperGenerators.js';

// Order listing is served by the CQRS handler at /api/common/storefront-orders/listItems
// (returns OrderResForListing). The remaining CRUD ops still target the legacy orders controller.
export const fetchItems = fetchItemsGen('/api/common/storefront-orders', 'listItems');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath);

export default {
  fetchItems,
  deleteItem,
  getItemById,
  addItem,
  editItem
};
